import { create } from 'zustand';

/**
 * Shared signal for scrolling to and highlighting a newly created folder.
 *
 * Used by FolderSecurityDialog (writer) and every FolderItemList-based list
 * component (readers).
 */
interface FolderScrollState {
  /** ID of the folder that was just created. Cleared after 2 s. */
  newFolderId: string | null;
  requestScrollToNewFolder: (id: string) => void;
  clearNewFolderId: () => void;
}

export const useFolderScrollStore = create<FolderScrollState>((set) => ({
  newFolderId: null,
  requestScrollToNewFolder: (id) => set({ newFolderId: id }),
  clearNewFolderId: () => set({ newFolderId: null }),
}));
